import { routerPostCall } from '../../axios';
// authPostCall
const googleRedirect = (state, params) => {
  const url = `/auth/googleUser`;
  return routerPostCall(state, url, params);
};
export default { googleRedirect };
